module.exports = __webpack_public_path__ + "img/清河羊绒.b8f9239b.jpg";